import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/base'
import './plugins/vee-validate'
import vuetify from './plugins/vuetify'
import i18n from './i18n'

import { sync } from 'vuex-router-sync'
import syncLoggedView from './lib/syncLoggedView'

import firebase from 'firebase/app'
import 'firebase/auth'

import VueGtm from '@gtm-support/vue2-gtm'

Vue.config.productionTip = false

sync(store, router)
syncLoggedView(store, router)

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
}
firebase.initializeApp(firebaseConfig)

Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTAG_ID,
  defer: false,
  compatibility: false,
  enabled: process.env.VUE_APP_GTAG_ACTIVE,
  debug: false,
})

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
